import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IconName } from '@vsolv/vectors-ui/icons';
import { AppCardDialog } from '../../dialogs';

export interface AppCardConfig {
  title: string;
  body: string;
  icon: IconName;
  poweredBy: {
    name: string;
    icon: string;
  };
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-app-card[config]',
  templateUrl: './app-card.component.html',
  standalone: false,
})
export class AppCardComponent {
  @Input() config!: AppCardConfig;

  @Input() enabled!: boolean;

  /** Shows a neutral "Configured" tag when credentials exist but the app isn't the active one (ignored while enabled). */
  @Input() configured = false;

  @Output() dialogOpened = new EventEmitter<void>();

  @Output() dialogClosed = new EventEmitter<void>();

  @ViewChild('dialog') dialog?: AppCardDialog;

  openDialog() {
    this.dialog?.openDialog();
  }

  closeDialog() {
    this.dialog?.closeDialog();
  }
}
